import type { ButtonProps } from "@braintrust/braintrust-ui-components";
import { Button } from "@braintrust/braintrust-ui-components";
import { useNavigate } from "@js/hooks/navigate";

type CompleteProfileButtonProps = Partial<ButtonProps>;

export const CompleteProfileButton = ({
  ...props
}: CompleteProfileButtonProps) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="primary"
      onClick={() => {
        navigate("/complete_profile");
      }}
      {...props}
    >
      Complete profile
    </Button>
  );
};
